import { resolveSiteConfig } from './siteProfiles'
import type { AuthProvider, PaymentMethod } from '../types/site'

export function useSiteConfig() {
  const publicConfig = useRuntimeConfig().public
  const siteConfig = resolveSiteConfig({
    siteEdition: publicConfig.siteEdition,
    deploymentRegion: publicConfig.deploymentRegion,
    counterpartSiteUrl: publicConfig.counterpartSiteUrl,
  })

  const siteEdition = computed(() => siteConfig.edition)
  const isAiSite = computed(() => siteConfig.edition === 'ai')
  const isVipSite = computed(() => siteConfig.edition === 'vip')
  const deploymentRegion = computed(() => siteConfig.deploymentRegion)
  const authProviders = computed<AuthProvider[]>(() => siteConfig.capabilities.authProviders)
  const paymentMethods = computed<PaymentMethod[]>(() => siteConfig.capabilities.paymentMethods)
  const accountDomainMigration = computed(() => siteConfig.capabilities.accountDomainMigration)
  const counterpartSiteUrl = computed(() => siteConfig.counterpartSiteUrl)

  return {
    siteEdition,
    isAiSite,
    isVipSite,
    deploymentRegion,
    authProviders,
    paymentMethods,
    accountDomainMigration,
    counterpartSiteUrl,
  }
}
